"use clent";

import React from "react";
import "./styles.css";
import "../common.css";

export const FeatureBlock = ({
	title,
	children,
	backgroundColor = "#fff",
	borderRadius = 0,
	textColor = "#242323",
	cards = false,
}) => {
	return (
		<div
			className={
				borderRadius ? "feature__wrapper fix-spacing" : "feature__wrapper"
			}
			style={{
				background: backgroundColor,
				borderRadius: borderRadius,
				marginTop: borderRadius ? borderRadius * -1 : 0,
				marginBottom: borderRadius ? borderRadius * -1 : 0,
				position: borderRadius ? "relative" : "static",
				color: textColor,
			}}
		>
			<div className="container">
				{title && <div className="feature__title">{title}</div>}
				{cards ? <div className="feature__minirow">{children}</div> : children}
			</div>
		</div>
	);
};
